import React from 'react';
import {Divider, Input, message, Modal, Table} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";

const { TextArea } = Input;

export default class EthWithdrawList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            inviteCode: '',
            password: '',
            showMessageDialog: false,
            showConfirmModal: false,
            confirmLoading: false,
            currentPage: 1,
            pageSize: 10,
        }
    }

    componentDidMount() {
        this.loadListData();
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    handleInputFocus(event) {
        const target = event.target;
        if (target.type === 'text') {
            this.setState({showMessageDialog: false});
        }
    }

    loadListData(changedParams) {
        let params = this.state;
        Object.assign(params, changedParams);
        Object.assign(this.state, params);

        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/query-withdraw-list', {
            currentPage: params.currentPage,
            pageSize: params.pageSize,
            withdrawStatus: 1,
        }).then(response => {
            console.debug("query-user-sales-list response -> " + JSON.stringify(response));
            this.setState({loading: false});
            if (response.code === 200) {
                this.setState({
                    dataList: response.rows,
                    total: response.total,
                    currentPage: changedParams.currentPage,
                    pageSize: changedParams.pageSize
                });
            } else if (response.code === 401 || response.code === 403) {
                this.props.history.push('/login');
            } else {
                message.error(response['msg']);
            }
        }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    render() {
        return (
            <div className="container">
                <Table loading={this.state.loading}
                       rowKey={'id'}
                       columns={[
                           {title: 'Currency', dataIndex: 'currency', align: 'center'},
                           {title: 'Address', dataIndex: 'receiptAddress', align: 'center'},
                           {
                               title: 'Amount', dataIndex: 'amount', align: 'center',
                               render: (value) => {
                                   return CommonUtils.toDecimal(value, 6)
                               }
                           },
                           {
                               title: 'Fee', dataIndex: 'fee', align: 'center',
                               render: (value) => {
                                   return CommonUtils.toDecimal(value, 6)
                               }
                           },
                           {
                               title: 'Status', dataIndex: 'withdrawStatus', align: 'center',
                               render: (text, record) => {
                                   if (text == 1) {
                                       return 'Applied'
                                   } else if (text == 2) {
                                       return 'paid';
                                   } else if (text == 3) {
                                       return 'completed';
                                   }
                               }
                           },
                           {title: 'Time', dataIndex: 'createdTime', align: 'center'},
                           {
                               title: 'Action',
                               key: 'action',
                               align: 'center',
                               render: (text, record) => (
                                   <span>
                                        <a onClick={() => this.showInfoModal(record)}>View Info</a>
                                        <Divider type="vertical"/>
                                        <a onClick={() => this.showRejectModal(record.id)}>Reject</a>
                                        <Divider type="vertical"/>
                                        <a onClick={() => this.showPaymentModal(record.id)}>Mark Paid</a>
                                  </span>
                               ),
                           },
                       ]}
                       dataSource={this.state.dataList}
                       pagination={{
                           current: this.state.currentPage,
                           pageSize: this.state.pageSize,
                           total: this.state.total,
                           onChange: (currentPage, pageSize) => {
                               this.setState({loading: true});
                               this.loadListData({currentPage, pageSize});
                           }
                       }}/>

                <Modal
                    title="Reject Withdraw"
                    visible={this.state.showConfirmModal}
                    onCancel={() => this.setState({showConfirmModal: false})}
                    onOk={() => this.handleWithdraw(5, this.state.remarks)}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                    <TextArea name={'remarks'} rows={2} placeholder={'Reject reason'}
                              onChange={this.handleInputChange.bind(this)}/>
                </Modal>
            </div>
        )
    }

    showInfoModal(row){
        new WebServerRestClient().GET('/admin/query-user-balance', {
            userId: row.userId,
            currency: row.currency
        }).then(response => {
            console.log("query-user-balance response -> " + JSON.stringify(response));
            if (response.code == 200) {
                Modal.info({
                    title: 'Withdraw Info',
                    content: (
                        <table>
                            <tbody>
                                <tr>
                                    <td style={{width: 80}}>UID:</td>
                                    <td>{row.userId}</td>
                                </tr>
                                <tr>
                                    <td>Amount:</td>
                                    <td style={{color: '#a74ab5'}}>{row.amount}</td>
                                </tr>
                                <tr>
                                    <td>Balance:</td>
                                    <td style={{color: 'green'}}>{response.data}</td>
                                </tr>
                            </tbody>
                        </table>
                    ),
                    onOk() {},
                });
            } else {
                message.warn(response['msg']);
            }
        }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

    showRejectModal(orderId){
        this.setState({
            showConfirmModal: true,
            orderId: orderId
        });
    };

    showPaymentModal(orderId){
        this.setState({orderId: orderId});
        Modal.confirm({
            title: 'Confirm',
            content: 'Mark the record to paid state?',
            onOk: () => this.handleWithdraw(2),
            confirmLoading: this.state.confirmLoading
        });
    };

    handleWithdraw (status, remarks) {
        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/handle-withdraw', {
            orderId: this.state.orderId,
            remarks: remarks,
            status: status
        }).then(response => {
            console.log("login response -> " + JSON.stringify(response));
            this.setState({showConfirmModal: false, confirmLoading: false});
            if (response.code == 200) {
                this.loadListData();
            } else {
                this.setState({showMessageDialog: true, message: response['msg']});
            }
        }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

}
